"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2022, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const redux_1 = require("redux");
const redux_thunk_1 = require("redux-thunk");
const auth_1 = require("./auth");
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || redux_1.compose;
const initialState = {};
exports.default = (preloadedState = initialState) => {
    const store = (0, redux_1.createStore)((0, redux_1.combineReducers)({
        auth: auth_1.authReducer
    }), preloadedState, composeEnhancers((0, redux_1.applyMiddleware)(redux_thunk_1.thunk)));
    return store;
};
//# sourceMappingURL=configureStore.js.map